// extracted by mini-css-extract-plugin
export default {"rootContainer":"MainLayout_rootContainer__YQsal","mainContainer":"MainLayout_mainContainer__DideK","content":"MainLayout_content__7fz-U"};